import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'subcoursetopic/';

export const getAllSubCourseTopics = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};